export const productViewItemControls = {
    productListCtrl: 'productListCtrl',
    colorsViewer: 'colorsViewer',
    photosCarousel: 'photosCarousel',
    productViewScrollPhotos: 'productViewScrollPhotos',
    colorsViewerCarousel: 'colorsViewerCarousel',
};
